import type { BatchPreviewPageDescriptionProps } from "./batch-preview-page-description.type";

import { Typography } from "antd";
import { Trans } from "react-i18next";

import "./batch-preview-page-description.style.less";

const { Title } = Typography;

export const BatchPreviewPageDescription = ({
  i18nKey,
  values,
  components,
}: BatchPreviewPageDescriptionProps) => {
  return (
    <Trans
      i18nKey={i18nKey}
      parent={(props) => (
        <Title
          level={3}
          className="batch-preview-page-description"
          {...props}
        />
      )}
      values={values}
      components={components}
    />
  );
};
